import type { App } from 'vue';
import VueFinder from 'vuefinder/dist/vuefinder';

/**
 * Components only loaded in the client bundle
 *
 * @param app
 */
export function addClientOnlyComponents(app: App) {
  // vuefinder bundling is a bit weird and it is only render client-side anyway, since all library
  // pages are not rendered via ssr (requires user data).
  app.use(VueFinder);
}
